/**
 * _vertical-navigation.js
 * @author      Marc-André Appel <marc-andre@sudimage.fr>
 * @copyright   2017 Sudimage Communication
 * @license     http://opensource.org/licenses/MIT MIT
 * @link        https://www.sudimage.fr
 * @created     27/06/2017
 */

(() => {
    "use strict";

    const fixed = () => {
        let breakpoint = $('main').offset().top - 50;
        let top = 50;
        const ccmToolbar = 48;
        const parentWidth = $verticalNavigation.parent().parent().width();

        if ($html.hasClass('ccm-toolbar-visible')) {
            breakpoint -= ccmToolbar;
            top += ccmToolbar;
        }

        $window.scroll(() => {
            let scrollPos = $('html').scrollTop() || $('body').scrollTop();

            if (scrollPos > breakpoint) {
                $verticalNavigation.css({
                    position: 'fixed',
                    top: top,
                    width: parentWidth
                });
            } else {
                $verticalNavigation.css({
                    position: 'initial',
                    top: 'initial',
                    width: 'initial'
                });
            }
        });
    };

    function accordion() {
        $('> li', $verticalNavigation).each(function () {
            const $this = $(this);
            if ($this.children('ul').length > 0) {
                if ( ! $this.hasClass('in-path')) {
                    $this.addClass('closed');
                } else {
                    $this.addClass('opened');
                }
                $('> a', $this).on('click', function (e) {
                    e.preventDefault();
                    closeAccordion();
                    openAccordion($(this));
                });
            }
        });
        function closeAccordion() {
            const target = $verticalNavigation.children('li.opened');
            $('ul', target).slideUp(250, function () {
                $('ul', target).hide();
            });
            target.addClass('closed').removeClass('opened');
        }
        function openAccordion(elem) {
            const target = elem.parent('li');
            $('ul', target).slideDown(250, function () {
                $('ul', target).show();
            });
            target.addClass('opened').removeClass('closed');
        }
    }

    if ( ! CCM_EDIT_MODE) {
        $document.ready(() => {
            if (window.isNotMobile && $window.width() >= 768) {
                accordion();
                fixed();
                $window.resize(() => {
                    fixed();
                });
            }
        });
    }
})($window, $document, $verticalNavigation);